export enum StepType {
  Email = 'Email',
  WriteWithAi = 'Write With AI',
  LinkedIn = 'LinkedIn Manual Task',
  Call = 'Call',
  WhatsApp = 'WhatsApp',
  Task = 'Task',
  LinkedInAutomation = 'LinkedIn Automation',
}
